'use strict';

const CHARTS_URL = 'https://www.gstatic.com/charts/loader.js';

let load_promise = null;

export function load_google_charts(timeout_ms = 10000) {
	if (window.google && window.google.charts) {
		return Promise.resolve(window.google);
	}
	if (load_promise) {
		return load_promise;
	}
	load_promise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		const timer = window.setTimeout(() => {
			load_promise = null;
			script.remove();
			reject(new Error('google charts load timeout'));
		}, timeout_ms);
		script.src = CHARTS_URL;
		script.async = true;
		script.onerror = () => {
			window.clearTimeout(timer);
			load_promise = null;
			script.remove();
			reject(new Error('google charts script failed to load'));
		};
		script.onload = () => {
			window.clearTimeout(timer);
			resolve(window.google);
		};
		document.head.appendChild(script);
	});
	return load_promise;
}

export function load_corecharts(google, timeout_ms = 10000) {
	return new Promise((resolve, reject) => {
		const timer = window.setTimeout(() => {
			reject(new Error('google charts corechart load timeout'));
		}, timeout_ms);
		google.charts.load('current', {
			packages: ['corechart'],
			callback: () => {
				window.clearTimeout(timer);
				resolve();
			}
		});
	});
}
